 <template>
  <div class="columns is-multiline">
    <div v-for="(article, key) in articles" v-bind:key="key" class="column is-full">
      <div class="card">
        <div class="card-content">
          <div class="tags">
            <span v-for="(label, index) in article.labels"
            v-bind:key="index" class="tag" v-bind:class="label.class">
              <a href="#">{{ label.name }}</a>
            </span>
          </div>
          <p class="title is-4">
            <a href="/app-views/article">{{ article.title }}</a>
          </p>
          <p class="subtitle is-6 text-unimportant">
            <i class="fas fa-clock"></i>
            <time datetime="2018-03-16">{{ article.date }} </time>
            by
            <a href="#">@{{ article.author }}</a>
          </p>
          <div class="columns">
            <div class="column is-narrow">
              <p>
                <img :src="article.image" v-if="article.image" />
              </p>
            </div>
            <div class="column">
              <p>{{ article.text }}
                <a href="/app-views/article">view more</a>
              </p>
            </div>
          </div>
          <div class="level">
            <strong>{{ article.nrComments }} comments</strong>
            <!-- <h2 class="subtitle">Preset Stars</h2> -->
            <star-rating :star-size="25" :show-rating="false"
            :rating="article.ratingValue" :read-only="true"></star-rating>
          </div>
          <div class="tags">
            <span v-for="(tag, index) in article.tags" v-bind:key="index" class="tag">
              <a href="#">#{{ tag }}</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>
<style>
.tags a {
  color: inherit;
}

p {
  /*font-size: 0.8em;*/
  padding-top: 0.3em;
  padding-bottom: 0.3em;
}

.box {
  padding-left: 2em;
  padding-right: 2em;
}

.text-unimportant {
  color: #969494;
}

.card {
  margin-bottom: 1em;
  margin-top: 1em;
}

.is-full-width {
  width: 100%;
}
</style>

<script>
import StarRating from 'vue-star-rating'

export default {
  components: {
    StarRating
  },
  data () {
    return {
      articles: [
        {
          title: 'Finibus Bonorum et Malorum',
          date: '16/03/2018 - 11:09 PM',
          author: 'Cicero',
          image: 'https://picsum.photos/150/150?image=10',
          text: 'At vero eos et accusamus et iusto odio dignissimos\
          ducimus qui blanditiis praesentium voluptatum deleniti atque\
          corrupti quos dolores et quas molestias excepturi sint occaecati\
          cupiditate non provident, similique sunt in culpa qui officia\
          deserunt mollitia animi, id est laborum et dolorum fuga.',
          nrComments: 4,
          ratingValue: 5,
          tags: ['TAG 1', 'TAG 2'],
          labels: [
            {
              name: 'Books',
              class: 'is-link'
            },
            {
              name: 'Food',
              class: 'is-warning'
            }
          ]
        },
        {
          title: 'Lorem Ipsum',
          date: '16/03/2018 - 11:09 PM',
          author: 'Lorem Ipsum',
          image: 'https://picsum.photos/150/150?image=20',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,\
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\
          Ut enim ad minim veniam, quis nostrud exercitation ullamco labori\
          nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in\
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
          nrComments: 1,
          ratingValue: 2,
          tags: ['TAG 1', 'TAG 2', 'TAG 3', 'TAG 4', 'TAG 5'],
          labels: [
            {
              name: 'info',
              class: 'is-primary'
            },
            {
              name: 'important',
              class: 'is-danger'
            },
          ]
        },
        {
          title: 'Article',
          date: '16/03/2018 - 11:09 PM',
          author: 'awesomewriter',
          image: 'https://picsum.photos/150/150?image=30',
          text: 'Nam dignissim congue lectus. Suspendisse eget\
          eros tellus. Aenean vel ex vulputate, pellentesque magna\
          at, imperdiet lacus. Vivamus vel purus turpis. Fusce\
          convallis rutrum nisi, vitae blandit purus scelerisque vitae.\
          Morbi dapibus ipsum eu purus consequat, a ornare orci consectetur.',
          nrComments: 0,
          ratingValue: 3,
          tags: ['Article Tag'],
          labels: [
            {
              name: 'Important',
              class: 'is-danger'
            },
          ]
        },
        {
          title: 'Kafka Quote',
          date: '16/03/2018 - 11:09 PM',
          author: 'Kafka',
          image: 'https://picsum.photos/150/150?image=40',
          text: 'One morning, when Gregor Samsa woke from troubled dreams,\
          he found himself transformed in his bed into a horrible vermin.\
          He lay on his armour-like back, and if he lifted his head a\
          little he could see his brown belly, slightly domed and divided\
          by arches into stiff sections. The bedding was hardly able to\
          cover it and seemed ready to slide off any moment. His many legs,\
          pitifully thin compared with the size of the rest of him, waved\
          about helplessly as he looked. "What\'s happened to me?" he\
          thought. It wasn\'t a dream. His room, a proper human',
          nrComments: 2,
          ratingValue: 5,
          tags: ['Kafka', 'Dummy'],
          labels: [
            {
              name: 'Quotes',
              class: 'is-info'
            }
          ]
        },
        {
          title: 'Cicero',
          date: '16/03/2018 - 11:09 PM',
          author: 'Cicero',
          image: 'https://picsum.photos/150/150?image=50',
          text: 'But I must explain to you how all this mistaken\
          idea of denouncing pleasure and praising pain was born\
          and I will give you a complete account of the system,\
          and expound the actual teachings of the great explorer\
          of the truth, the master-builder of human happiness.\
          No one rejects, dislikes, or avoids pleasure itself,\
          because it is pleasure, but because those who do not\
          know how to pursue pleasure rationally encounter\
          consequences that are extremely painful. Nor again\
          is there anyone who loves or pursues or desires to\
          obtain pain of itself, because it is pain, but because occasionally',
          nrComments: 7,
          ratingValue: 3,
          tags: ['Cicero', 'Quote', 'Dummy Text'],
          labels: [
            {
              name: 'Cicero',
              class: 'is-danger'
            },
            {
              name: 'Dummy',
              class: 'is-warning'
            }
          ]
        }
      ]
    }
  }
}
</script>
